module.exports = {
  EnrichedPlayer: {
    Allow_fullscreen: "Permitir Pantalla Completa",
    Show_controls: "Mostrar Controles",
    Replay: "Reproducir de nuevo",
    Autoplay: "Reproducción Automática",
    URL: "URL",
    Video: "Vídeo",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    PluginName: "Reproductor Vídeo",
    pos: "Momento",
    radius: "Radio",
    source: "Origen",
    message_mark_error:
      "Ha introducido un valor incorrecto. Debe introducir el tiempo en el formato hh:mm:ss o mm:ss. Ej. 1:33",
    Loop: "Bucle",
    Sound: "Sonido",
    AutoPlay: "Reproducción automática",
    DownloadStyled: "Descargar con estilo",
    DownloadStyledProgress: "Generando… {{p}}%",
    DownloadStyledCancel: "Cancelar",
    DownloadStyledFailed: "Error en la descarga",
    DownloadWithSound: "Descargar con sonido (clic para silenciar)",
    DownloadMuted: "Descargar sin sonido (clic para activar)",
  },
};
